/*-----------------------------------------------------------------
- Card
-----------------------------------------------------------------*/
export default {

    title   : 'ترخینه ، آشنای خانواده',
    subtitle: 'غلات، حبوبات، ادویه جات، بسته بندی، غذای آماده، سوخاری، سوپ آماده، رشته، آرد',
    
    button: {
        content: 'فروشگاه آنلاین',
    },

};
